import { useAppSelector } from 'redux/store';
import { useIsAdminUser } from './useIsAdminUser';

export const useIsFeatureEnabled = (featureName: string): boolean => {
  const user = useAppSelector(state => state.userSlice?.user);

  const enabledFeatures = user?.enabledFeatures;

  return enabledFeatures?.includes(featureName) ?? false;
};

export const useIsAdminFeature = (featureName: string): boolean => {
  const isAdmin = useIsAdminUser();
  const isFeatureEnabled = useIsFeatureEnabled(featureName);

  return isAdmin && isFeatureEnabled;
};
